export const testingLoading = false;

export const p1 = {
  ds: 10,
  ms: 10,
  mxs: 10,
};

export const p2 = {
  ds: 100 - p1.ds,
  ms: 100 - p1.ds,
  mxs: 100 - p1.ds,
};

export const fpnf = {
  fetchPolicy: "cache-first",
  notifyOnNetworkStatusChange: true,
  errorPolicy: "all",
};

export const labels = {
  assessmentsSummary: "Application Assessment Summary",
  assCounts: {
    filesCount: "Files Count",
    sbom: "SBOM",
    vulnerabilities: "Vulnerabilities",
    findings: "Findings",
  },
};

export const defaultAssDataSummary = {
  data: [],
  counts: {
    filesCount: -1,
    sbom: -1,
    vulnerabilities: -1,
    findings: -1,
  },
};
